import { createAsyncThunk } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";
import { cloudChiprApi } from "../../../../../services/cloudchipr.api";
import { RootState } from "../../../../store";
import { recommendationRestoreFixedCacheKey } from "../../../utils/constants/fixedCacheKeys";
import { recommendationComputeDismissedDataSelector } from "../../../selectors/off-hours/data/compute/recommendationComputeDismissedDataSelector";
import { recommendationDbDismissedDataSelector } from "../../../selectors/off-hours/data/database/recommendationDbDismissedDataSelector";

export const restoreDailyOffHoursRecommendationThunk = createAsyncThunk(
  "recommendations/restoreDailyOffHoursRecommendationThunk",
  async (ids: string[], { dispatch, getState }) => {
    const state = getState() as RootState;

    const { patchUsersMeOrganisationsCurrentRecommendationsDailyOffHours } =
      cloudChiprApi.endpoints;

    const dismissedCompute = recommendationComputeDismissedDataSelector(state);
    const dismissedDb = recommendationDbDismissedDataSelector(state);

    const accountIds = ids.map((recommendationId) => {
      let recommendation = dismissedCompute?.find(
        ({ id }) => id === recommendationId,
      );

      if (!recommendation) {
        recommendation = dismissedDb?.find(({ id }) => id === recommendationId);
      }

      return recommendation?.account?.id ?? "";
    });

    try {
      return await dispatch(
        patchUsersMeOrganisationsCurrentRecommendationsDailyOffHours.initiate(
          {
            restoreRecommendationRequest: {
              account_ids: accountIds,
              recommendation_ids: ids,
            },
          },
          {
            fixedCacheKey: recommendationRestoreFixedCacheKey,
          },
        ),
      ).unwrap();
    } catch (error: any) {
      enqueueSnackbar(error?.data?.message ?? "Something went wrong.", {
        variant: "snackbarAlert",
        AlertSnackBarProps: {
          severity: "error",
        },
      });
    }
  },
);
